export default (data, page = 1, limit = 0, extraData = {}) => {
  return data.map((items, index) => {
    return {
        ...items, 
        num: (index + ((page - 1) * limit + 1)) ,
        ... extraData
    }
  })
}
